import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: '[formatearMiles]'
})
export class FormatearMilesDirective {
  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target;
    const limpio = input.value.replace(/,/g, '');
    if (!isNaN(Number(limpio))) {
      input.value = Number(limpio).toLocaleString('en-US');
    }
  }
}